import { configureStore } from "@reduxjs/toolkit";
import ComponentReducer from "./ComponentSlice";
import CardsReducer from "./CardsSlice";
import  TableReducer from "./TableSlice";
import  AppReducer from "./AppSlice";


export const store = configureStore({
  reducer: {
    callComponent: ComponentReducer,
    CardsComponent: CardsReducer,
    TableComponent: TableReducer,
    AppComponent: AppReducer,
  },
});
